function setQueryParams(obj) {
  let searchParams = new URLSearchParams(window.location.search);
  for (let i in obj) {
    searchParams.set(i, obj[i]);
  }
  const newRelativePathQuery =
    window.location.pathname + "?" + searchParams.toString();
  // console.log(obj, newRelativePathQuery);
  window.history.pushState(null, "", newRelativePathQuery);
}

export { setQueryParams };
